<template>
    <AppHeader
        hide-back
        :safe-area-top="false"
        style="--beyond-header-height: 64px"
    >
        <template #title>
            More
        </template>
    </AppHeader>
    <More />
</template>

<script setup>
    import More from '@/components/shared/More.vue'
    import { statusBar } from '@/services'

    onMounted(() => {
        statusBar.setTheme()
    })

    onActivated(() => {
        statusBar.setTheme()
    })
</script>
